import { memo } from 'react';

import { Button } from '@/shadcn/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/shadcn/dialog';

import { TestId } from '@/types/testId';

type Props = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  participantsStr: string;
  onSubmit: () => void;
};

/**  The modal to confirm the removal of a set of group members */
export const RemoveGroupMembersModal = memo(
  ({ isOpen, onOpenChange, groupName, participantsStr, onSubmit }: Props) => (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove from group</DialogTitle>
          <DialogDescription>
            Are you sure you want to remove <b>{participantsStr}</b> from the{' '}
            <b>{groupName}</b> group?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              data-testid={TestId.RemoveGroupMembersModal.CancelButton}
              variant="outline"
            >
              Cancel
            </Button>
          </DialogClose>
          <Button
            aria-label={`Click to remove ${participantsStr} from group ${groupName}.`}
            autoFocus
            data-testid={TestId.RemoveGroupMembersModal.SubmitButton}
            disabled={!groupName}
            onClick={onSubmit}
            type="submit"
            variant="destructive"
          >
            Remove
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
);
